<template lang="pug">

  .reload-card-init-form
    form(@submit.prevent="check", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row(:form="form", name="number", :label="$t('reload.number')")
        input.form-control.playcard-control(v-model="form.number", type="text", name="number", :class="{'is-invalid': form.errors.has('number')}", :placeholder="$t('reload.number_placeholder')" autocomplete="off")
      .form-group
        a.form-link(href="#", @click.prevent="showWhatsThisModal = true") {{ $t('reload.what_is_this') }}
      form-group-row(:form="form", name="cvv", :label="$t('reload.cvv')")
        form-input.cvv-control(:form="form", name="cvv", type="password", :placeholder="$t('reload.cvv_placeholder')" autocomplete="off")
      .form-group
        a.form-link(href="#", @click.prevent="showWhatsCvvModal = true") {{ $t('reload.what_is_this') }}
      .form-group
        v-button.btn-default(:loading="form.busy", block) {{ $t('reload.submit') }}

    modal(v-if="showWhatsThisModal", @close="showWhatsThisModal = false")
      .card-number-help

    modal(v-if="showWhatsCvvModal", @close="showWhatsCvvModal = false")
      .card-cvv-help

</template>

<script>
import Form from 'vform';

export default {
  name: 'reload-card-init-form',

  data: () => ({
    form: new Form({
      number: '',
      cvv: ''
    }),
    showWhatsThisModal: false,
    showWhatsCvvModal: false
  }),

  methods: {
    async check () {
      const { data } = await this.form.post(`${window.addiesaas.url}/api/playcards/playcard/details`);
      this.$router.push({ name: 'playcards.reload', params: { barcode: data.data.barcode } });
    }
  }
}
</script>
